import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import CheckCircle08 from "@dcl/icons/esm/nucleo/small/user-interface/check-circle-08";
import AlertHexagonExc from "@dcl/icons/esm/nucleo/small/user-interface/alert-hexagon-exc";
import { AlertState } from "./AlertTypes";

var renderAlertStateIcon = function renderAlertStateIcon(alertState) {
  switch (alertState) {
    case AlertState.SUCCESS:
      return /*#__PURE__*/React.createElement(CheckCircle08, {
        label: alertState,
        width: 24
      });

    case AlertState.FAILURE:
      return /*#__PURE__*/React.createElement(AlertHexagonExc, {
        label: alertState,
        width: 24
      });
  }
};

var Alert = function Alert(_ref) {
  var alertState = _ref.alertState,
      state = _ref.state,
      children = _ref.children,
      id = _ref.id;
  // eslint-disable-next-line
  alertState = alertState || state;
  var getClassName = getClassNameFactory(Alert.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      states: alertState
    }),
    role: "alert"
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "icon"
    })
  }, renderAlertStateIcon(alertState)), /*#__PURE__*/React.createElement("div", {
    id: id,
    className: getClassName({
      descendantName: "content"
    })
  }, children));
};

Alert.displayName = "Alert";
export default Alert;